module.exports = __webpack_public_path__ + "static/media/1021530.a71e2a88.jpg";